<template>
  <div>
    <ul v-if="appliancesList">
      <li @click="selectItem(appliance)" v-for="appliance in appliancesList" :key="appliance.iconFile">
        <img width="70px" :src="`appliances/${appliance.iconFile}` | s3Image" alt="">
        {{ appliance.name }}
      </li>
    </ul>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'

export default {
  name: 'ApplianceList',
  // props: ['onSelect'],
  data() {
    return {
    }
  },
  methods: {
    selectItem(appliance) {
      this.$emit('onSelect', appliance)
    }
  },
  computed: {
    ...mapState('appliancesStore', ['appliancesList'])
  },
  mounted() {}
}
</script>

<style lang="sass">
  .appliance-list-wrap
    position: relative

  .appliance-list
    position: absolute
    background-color: white
    width: auto
    top: 60px
    border: 1px solid #b9b9b9
    overflow-y: scroll
    max-height: 250px
    z-index: 100
    // height: 200px

    ul
      list-style: none
      padding: 0
      margin: 0
    //   display: flex
    //
    li
      padding: 5px
      display: block
      cursor: pointer

      &:hover
        background-color: #e2e2e2
    //   width: 40px
    //   height: 40px
    //   display: block
    //   background-color: blue
</style>



// WEBPACK FOOTER //
// ApplianceList.vue?64c83e14